import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { PlatformBrowserService } from "@Front-end/seed/services";
import { environment } from "../../environments/environment";
import { MirrorService } from "../services/mirror.service";

export const mirrorUrlResolverInterceptor: HttpInterceptorFn = (request, next) => {

    const browserService: PlatformBrowserService = inject(PlatformBrowserService);
    const mirrorService: MirrorService = inject(MirrorService);
    const isMirror: boolean = mirrorService.isMirror();
    const serviceWindow: Window | null = browserService.window;

    if (serviceWindow && isMirror) {
        const currentHost = serviceWindow.location.host.split(".")[0];
        const projectHost = environment.uniqueProjectTranslation.projectName.toLowerCase();

        if (environment.production && currentHost !== projectHost) {
            const TEMP = "TEMP";
            let url = request.url.replace(projectHost, TEMP);
            url = url.replace(projectHost, currentHost);
            url = url.replace(TEMP, projectHost);
            const dupReq = request.clone({ url });
            return next(dupReq);
        }
    }
    return next(request);
};
